import React from 'react';
import { Checkbox } from './Checkbox';
import { Property } from '../../ducks/property/types';

interface HotPropertyToggleProps {
    property: Property;
    onToggle: (property: Property) => void;
    disabled?: boolean;
}

export const HotPropertyToggle: React.FC<HotPropertyToggleProps> = ({
    property,
    onToggle,
    disabled = false,
}) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <Checkbox
                name={`hot-${property.id}`}
                variant="empty"
                checked={property.is_hot}
                onChange={() => onToggle(property)}
                disabled={disabled}
            />
        </div>
    );
};
